export default __webpack_public_path__ + "static/media/baby-18.0c1359c4.svg";